"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Integration_1 = require("../Integration");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
let ActiveCampaign = class ActiveCampaign extends Integration_1.Integration {
    constructor() {
        super(...arguments);
        this.integrationType = 'ActiveCampaign';
        this.displayType = 'ActiveCampaign';
        this.isESP = true;
    }
    get activeCampaignApiUrlBase() {
        if (this.activeCampaignApiUrl) {
            return this.activeCampaignApiUrl;
        }
        return `https://${this.activeCampaignOrganizationSlug}.api-us1.com/api`;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], ActiveCampaign.prototype, "integrationType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "displayType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], ActiveCampaign.prototype, "canConnect", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "isESP", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "activeCampaignOrganizationSlug", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "activeCampaignApiUrl", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "activeCampaignWorkspaceUrl", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaign.prototype, "apiSecretKey", void 0);
ActiveCampaign = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.ChildEntity()
], ActiveCampaign);
exports.ActiveCampaign = ActiveCampaign;
//# sourceMappingURL=ActiveCampaign.js.map